@if (srcset) {
  @if (photo) {
    <img appImageFade
      draggable="false"
      class="object-cover absolute w-full h-full"
      [src]="src|bypassSecurity:'url'"
      [srcset]="srcset"
      [sizes]="sizes"
      [alt]="alt"
      [style.object-position]="(50 + (photo.focusX * 50)) + '% ' + (50 + (-photo.focusY * 50)) + '%'"
      >
  } @else {
    <div class="relative w-full h-full bg-neutral-4">
      <img class="absolute top-1/2 left-1/2 w-1/3 h-auto transform -translate-x-1/2 -translate-y-1/2" src="/assets/images/placeholder.svg" [alt]="alt">
    </div>
  }
} @else {
  @if (photo && src) {
    <img appImageFade
      draggable="false"
      class="object-cover absolute w-full h-full"
      [src]="src|bypassSecurity:'url'"
      [alt]="alt"
      [style.object-position]="(50 + (photo.focusX * 50)) + '% ' + (50 + (-photo.focusY * 50)) + '%'"
      >
  } @else {
    <div class="relative w-full h-full bg-neutral-4">
      <img class="absolute top-1/2 left-1/2 w-1/3 h-auto transform -translate-x-1/2 -translate-y-1/2" src="/assets/images/placeholder.svg" [alt]="alt">
    </div>
  }
}

